module.exports = __webpack_public_path__ + "d94535cd80d46469e70aa3d7134c353c.png";